import AliasColor from "../../entities/AliasColor.js";
import HtmlUtils from "../../../components/HtmlUtils.js";

export default class SubstanceAliasDialog {
	/** @param {AliasColorScheme} aliasColorScheme
	 * @param {ColorPreset} scopeColors
	 */
	constructor(aliasColorScheme, scopeColors) {
		this._dialog = null;
		/** @deprecated */
		this._callbacks = [];
		this._aliasColorScheme = aliasColorScheme;
		this._scopeColors = scopeColors;
		this._callbacks_v2 = {
			onOk: [],
			onDelete: [],
		};
	}

	/**
	 * @param {AliasColor} aliasColor
	 * @param {{readOnly:boolean}} displayOptions
	 */
	render(aliasColor, displayOptions = {readOnly: false}) {
		this._dialog = this._createModal(SubstanceAliasDialog._htmlTemplate(displayOptions.readOnly));
		this._isColorFixed = this._scopeColors.getColor(aliasColor.alias) !== undefined;
		const
			colorPalette = this._dialog.querySelector('color-palette'),
			aliasInput = this._dialog.querySelector('#aliasInput'),
			okBtn = this._dialog.querySelector('.btn-ok'),
			cancelBtn = this._dialog.querySelector('.btn-cancel'),
			deleteBtn = this._dialog.querySelector('.btn-delete');

		aliasInput.value = aliasColor.alias;
		colorPalette.setColor(aliasColor.color);
		colorPalette.addEventListener('colorChanged', ()=>{
			this._isColorFixed = true;
		});
		cancelBtn.addEventListener('click', () => {
			this.remove();
		});
		this._dialog.addEventListener('keydown', (evt) => {
			evt.stopPropagation();
			if (evt.repeat) return;
			switch (evt.key) {
				case 'Enter' : {
					evt.preventDefault();
					if (okBtn && !okBtn.getAttribute('disabled') === true)
						okBtn.dispatchEvent(new Event('click'));
					break;
				}
				case 'Escape' :
					evt.preventDefault();
					if (!cancelBtn.getAttribute('disabled') === true)
						cancelBtn.dispatchEvent(new Event('click'));
			}
		})
		if (displayOptions.readOnly) {
			this.#setDialogReadOnly();
			return;
		}
		// --- if not readOnly
		okBtn.toggleAttribute('disabled', aliasInput.value.length === 0);
		aliasInput.addEventListener('input', () => {
			const alias = aliasInput.value;
			if (!this._isColorFixed)
				colorPalette.setColor(this._aliasColorScheme.getColor(alias));
			okBtn.toggleAttribute('disabled', !alias.length);
		});
		okBtn.addEventListener('click', async () => {
			if ([...this._dialog.querySelectorAll('text-input')].findIndex(i => !i.checkValidity()) !== -1) return;
			if (typeof this._callbacks['ok'] === 'function')
				await this._disableInputAndWait(this._callbacks['ok'].bind(this, this.getFormData()))
			this.#onOk();
		});
		if (aliasColor.alias.length !== 0)
			deleteBtn.addEventListener('click', async () => {
				if (typeof this._callbacks['delete'] === 'function')
					await this._disableInputAndWait(this._callbacks['delete'].bind(this, this.getFormData()))
				this.#onDelete();
			});
		else
			deleteBtn.remove();
		aliasInput.focus();
	}

	/**@deprecated*/
	on(eventName, callback) {
		this._callbacks[eventName] = callback;
	}

	onOk(callback) {
		this._callbacks_v2.onOk.push(callback);
	}

	onDelete(callback) {
		this._callbacks_v2.onDelete.push(callback);
	}

	enterLoadingMode() {
		const elementsInput = this._dialog.querySelectorAll('text-input');
		elementsInput.forEach(el => el.setDisabled(true));
		const elementsButton = this._dialog.querySelectorAll('button');
		elementsButton.forEach(el => el.setAttribute('disabled', true));
	}

	exitLoadingMode() {
		const elementsInput = this._dialog.querySelectorAll('text-input');
		elementsInput.forEach(el => el.setDisabled(false));
		const elementsButton = this._dialog.querySelectorAll('button');
		elementsButton.forEach(el => el.removeAttribute('disabled'));
	}

	remove() {
		this._dialog.remove();
	}

	/**@deprecated*/
	getFormData() {
		return {
			alias: this._dialog.querySelector('#aliasInput').value.trim(),
			color: this._dialog.querySelector('color-palette').getCurrentColor(),
		}
	}

	#setDialogReadOnly() {
		this._dialog.querySelector('#aliasInput').setDisabled(true);
	}

	#getFormData_v2() {
		return new AliasColor(
			this._dialog.querySelector('#aliasInput').value.trim(),
			this._dialog.querySelector('color-palette').getCurrentColor()
		);
	}

	showAliasErrorMsg(err) {
		const input = this._dialog.querySelector('#aliasInput');
		input.errorMessage = err;
		input.setDisabled(false);
		input.focus();
	}

	#onOk() {
		const aliasColor = this.#getFormData_v2();
		this._callbacks_v2.onOk.forEach(cb => cb(aliasColor));
	}

	#onDelete() {
		this._callbacks_v2.onDelete.forEach(cb => cb());
	}

	async _disableInputAndWait(func) {
		this.enterLoadingMode();
		try {
			await func();
		} finally {
			this.exitLoadingMode()
		}
	}

	_createModal(node) {
		return HtmlUtils.createModal(node);
	}

	/**
	 * @param {boolean} isReadOnly
	 * @returns {Node}
	 * @private
	 */
	static _htmlTemplate(isReadOnly = false) {
		let tmpl = document.createElement('template');
		tmpl.innerHTML = `
        <div id="create-alias-dialog" class="dialog">
          <div class="progress"><div class="indeterminate"></div></div>
          <div class="dialog-title">
          	<span>Set alias color</span>
          </div>
          <div class="dialog-content">
			<color-palette></color-palette>
			<div class="right-column">
			  <text-input id="aliasInput" label="Alias" minLength="1" maxLength="100"></text-input>
			</div>
          </div>
          <div class="dialog-buttons-row">
            ${isReadOnly ? '' : '<div class="justify-start"><button class="button button--text button--text-red btn-delete">Delete</button></div>'}
            <button class="button button--text btn-cancel">Close</button>
			${isReadOnly ? '': '<button class="button button--contained btn-ok" >Save</button>'}
          </div>
        </div>`;
		return tmpl.content.cloneNode(true);
	}
}